"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _useChiliPiperIntegration = require("../../hooks/useChiliPiperIntegration");

var _chiliPiperIntegration = require("../../store/chiliPiperIntegration/chiliPiperIntegration.actions");

var _ChiliPiperIntegrationForm = _interopRequireDefault(require("./components/ChiliPiperIntegrationForm"));

var ChiliPiperIntegration = function ChiliPiperIntegration() {
  var _useChiliPiperIntegra = (0, _useChiliPiperIntegration.useChiliPiperIntegration)(),
      isActive = _useChiliPiperIntegra.isActive,
      isLoading = _useChiliPiperIntegra.isLoading,
      url = _useChiliPiperIntegra.url;

  var dispatch = (0, _reactRedux.useDispatch)();
  var onSubmit = (0, _react.useCallback)(function (_ref) {
    var bookingLink = _ref.bookingLink;
    return dispatch((0, _chiliPiperIntegration.createChiliPiperIntegration)({
      url: bookingLink
    }));
  }, [dispatch]);
  var onDisconnect = (0, _react.useCallback)(function () {
    dispatch((0, _chiliPiperIntegration.disconnectChiliPiperIntegration)());
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    p: 4,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('H4-Dark-Bold')
  }, "Chili Piper Integration")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, isActive ? 'You can use your Chili Piper account to book meetings' : 'Integrating your Chili Piper account allows Alyce to automatically add meetings on your Chili Piper calendar any time a prospect accepts your terms. Less work for you and more meetings. Win win!')), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_ChiliPiperIntegrationForm.default, {
    defaultValues: {
      bookingLink: url === null ? '' : url
    },
    isLoading: isLoading,
    isSubmitEnabled: !isActive,
    onSubmit: onSubmit
  })), isActive && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onDisconnect,
    variant: "outlined",
    color: "red"
  }, "Disconnect Chili Piper Integration")));
};

var _default = ChiliPiperIntegration;
exports.default = _default;